<div class="main-form-box">
  <app-list-title title="עריכת אירוע" image="https://api.hanadiv.org/assets/Icons_Enterprise_Grey.svg"></app-list-title>
  <app-event-form [eventData]="eventData"></app-event-form>
</div>
